import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import swal from 'sweetalert2';
import { TooltipPosition, MatTooltipModule } from '@angular/material/tooltip';
import { ToastrService } from 'ngx-toastr';
import { UserSessionService } from 'services/usersession.service';
import { NavigationService } from 'services/navigation.service';
import * as moment from 'moment-timezone';
import { AuthenticationService } from 'services/authentication.service';
import { AlertService } from 'services/alert.service';
interface categoryList {
    value: string;
    id: number;
}
@Component({
    selector: 'app-add-support',
    templateUrl: './add-support.component.html',
    styleUrls: ['./add-support.component.scss'],
})
export class AddSupportComponent implements OnInit {
    addSupportForm: FormGroup;
    formSubmitted = false;
    CurrentLoginUserID: number = 0;
    documents: any[] = [];
    options: categoryList[] = [
        { value: 'Voice', id: 4 },
        { value: 'General', id: 5 },
        { value: 'Speed Issue', id: 6 },
        { value: 'Service Down', id: 7 },
        { value: 'Billing Enquiry', id: 8 }
    ];

    public filteredList5 = this.options.slice();

    positionOptions: TooltipPosition[] = ['below', 'above', 'left', 'right'];
    position = new FormControl(this.positionOptions[0]);
    fileName: string;
    dateWithTime: string;
    subject: string = '';
    isFileSelected: boolean = true;
    FileExtention: string;
    base64String: string;
    sessionDataString: any;
    userName: string;
    mobileNumber: string;
    showWarning: boolean = false;

    constructor(
        private fb: FormBuilder,
        private session: UserSessionService,
        private navigate: NavigationService,
        private toastr: ToastrService,
        private alertService: AlertService,
        private authservice: AuthenticationService
    ) { }

    ngOnInit(): void {
        this.subject = '';
        this.mobileNumber = this.session.userMobileNumber();
        console.log("Id:", this.mobileNumber)
        this.initializeValidators();
    }

    initializeValidators() {
        this.addSupportForm = this.fb.group({
            supportcategory: ['', Validators.required],

            subject: [null, [
                Validators.required,
                Validators.maxLength(100),
                // Validators.pattern('^[A-Za-z][A-Za-z\\- &]*$')
                 
                ]],
            query: [null, [
                Validators.required,
                Validators.minLength(4),
                Validators.pattern(/^(?!\s*$).+/)]],
        });
    }

    goBack() {
        this.navigate.support();
    }

    validateFormControl() {
        Object.keys(this.addSupportForm.controls).forEach((field) => {
            const control = this.addSupportForm.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({
                    onlySelf: true,
                });
            }
        });
    }

    saveSupportTicket() {
        if (this.addSupportForm.valid) {
            const finalValue = this.addSupportForm.value;
            var data = {
                userName: this.mobileNumber,
                supportcategory: finalValue.supportcategory,
                subject: finalValue.subject,
                query: finalValue.query,
            };
            this.authservice.createSupportTicket(data)
                .subscribe((res: any) => {
                    debugger;
                    if (res.isSuccess) {
                        const referenceNumber = res.value;
                        const Id = `<div><label style="font-weight:500;">Ticket Reference :</label><label style="color:#009DA0;font-weight:600;margin-top:12px;margin-left: 5px;">${referenceNumber}</label></div>`
                        swal.fire(
                            'Support Ticket',
                            'Your ticket has been logged successfully, our agents will be in contact with you.' + `${Id}`,
                            'success'
                        );
                        this.navigate.support();
                    }
                    else {
                        this.alertService.error(res.htmlFormattedFailures);
                    }
                });
        }
        else {
            this.validateFormControl();
            this.toastr.error("Please fill in all mandatory fields");
        }
    }

    // allowOnlyAlpha(event: KeyboardEvent) {
    //     const regex = /^[A-Za-z\- ]$/;
    //     if (!regex.test(event.key)) {
    //         event.preventDefault();
    //         this.showWarning = true;
    //         setTimeout(() => this.showWarning = false, 2000);
    //     }
    // }

}
